import React from 'react'
function Whatsappservice() {
  return (
    <>
    <section className="bg-gradient-to-br from-[#e710ea] to-black py-10 md:py-32">
        <div className="container mx-auto px-4 md:px-8 text-center">
          <h1 className="text-white font-bold font-serif text-4xl md:text-65l leading-tight mb-6 uppercase">
          WhatsApp Service's
          </h1>
          <p className="text-white text-lg md:text-2xl font-serif ">
          We offer WhatsApp service's, including WhatsApp Business API, BlueTick services, and chatbox solutions.
        These service's help businesses engage with customers directly on their preferred messaging platform.
          </p>
        </div>
   </section>
   
<section class="bg-zinc-50 overflow-hidden">
  <div class="max-w-screen-xl 2xl:max-w-screen-3xl px-8 md:px-12 mx-auto py-12 lg:py-24 space-y-12">
    <div class="grid grid-cols-1 md:grid-cols-3 gap-6">
      {/* <!-- WhatsApp Business API Card --> */}
      <div class="bg-gradient-to-b from-[#e710ea] to-black rounded-xl shadow-lg p-6 transform hover:scale-105 transition duration-500">
        <h3 class="text-xl font-semibold text-white  mb-2">WhatsApp Business API</h3>
        <p class="text-white ">
          Streamline business communication with automated messaging solutions for enhanced customer engagement.
        </p>
      </div>

      {/* <!-- WhatsApp Blue Tick Card --> */}
      <div class="bg-gradient-to-b from-[#e710ea] to-black rounded-xl shadow-lg p-6 transform hover:scale-105 transition duration-500">
        <h3 class="text-xl font-semibold text-white mb-2">WhatsApp Blue Tick Service</h3>
        <p class="text-white">
          Monitor message delivery and engagement with our Blue Tick service to track important communications.
        </p>
      </div>

      {/* <!-- Chatbox Solutions Card --> */}
      <div class="bg-gradient-to-b from-[#e710ea] to-black rounded-xl shadow-lg p-6 transform hover:scale-105 transition duration-500">
        <h3 class="text-xl font-semibold text-white mb-2">Chatbox Solutions</h3>
        <p class="text-white">
          Enhance customer interactions with customized chatbox solutions to handle queries and provide support efficiently.
        </p>
      </div>
    </div>
  </div>
</section>

      
    </>
  )
}

export default Whatsappservice